var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-section"},[_c('DashboardSectionHeader',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}}),_vm._v(" "),_c('div',{staticClass:"dashboard-section-body"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }